<template>
  <div class="reportData">
    <div class="flex-box flex-h-c nav bb">
      <div
        class="flex1 flex-box flex-hv-c"
        :class="{focus:currentType == 1}"
        @click="changType(1)"
      >元宝模式</div>
      <div
        class="flex1 flex-box flex-hv-c"
        :class="{focus:currentType == 2}"
        @click="changType(2)"
      >钻石模式</div>
      <div
        class="flex1 flex-box flex-hv-c"
        :class="{focus:currentType == 3}"
        @click="changType(3)"
      >业绩展示</div>
    </div>
    <div class=" flex-box flex-d-c flex-h-c">
      <div class="type-con" id="type-gold" v-show="currentType == 1">
        <div class="part">
          <p class="title">
              <span>元宝数据</span>
              <span class="detail-btn" @click="goldDetail">元宝提成金额历史明细&gt;</span>
          </p>
          <table id="data-table" class="data-table" cellpadding="0" cellspacing="0" >
              <tr class="table-title">
                  <td>类别</td>
                  <td>元宝付款金额</td>
                  <td>直属返利金额</td>
                  <td>元宝业绩金额</td>
                  <td>宝箱数</td>
                  <td>元宝提成金额</td>
                  <td>商务代理后台余额</td>
              </tr>
              <template v-for="(item , index) in goldDataList.moneyPayAmount">
                <tr v-if="index == 0" :key="index">
                    <td>今日</td>
                    <td colspan="6">第二天更新</td>
                </tr>
                <tr v-else :key="index">
                    <td>{{['昨日','本周','上周','本月','上月'][index - 1]}}</td>
                    <td v-text="goldDataList.moneyPayAmount[index]"></td>
                    <td v-text="goldDataList.moneyDirectFanliAmount[index]"></td>
                    <td v-text="goldDataList.moneyPerformanceAmount[index]"></td>
                    <td v-text="goldDataList.moneyTreasCnt[index]"></td>
                    <td v-text="goldDataList.moneyCommissionAmount[index]"></td>
                    <td v-text="goldDataList.moneyMemberBalance[index]"></td>
                </tr>
              </template>
          </table>
        </div>
        <div class="part">
          <p class="title">
              <span>场次数据</span>
          </p>
          <table id="data-table" class="data-table" cellpadding="0" cellspacing="0" >
              <tr class="table-title">
                  <td>类别</td>
                  <td>授权代理</td>
                  <td>开房数</td>
                  <td>元宝有效开房数</td>
                  <td>玩家数</td>
              </tr>
              <template v-for="(item , index) in goldDataList.list">
                <tr  :key="index">
                    <td v-text="item.name"></td>
                    <td v-text="item.totalCount"></td>
                    <td v-text="item.totalOpenRoom"></td>
                    <td v-text="item.moneyConsume"></td>
                    <td v-text="item.totalBindCount"></td>
                </tr>
              </template>
          </table>
        </div>
      </div>
      <div class="type-con" id="type-diamond" v-show=" currentType == 2 ">
            <div class="part">
                <p class="title">
                    <span>钻石数据</span>
                    <span class="detail-btn" @click="moneyDetail">提成金额历史明细&gt;</span>
                </p>
                <table class="data-table">
                    <tr class="table-title">
                        <td>类别</td>
                        <td>消耗钻石总数</td>
                        <td>无提成钻石消耗数</td>
                        <td>业绩钻石数</td>
                        <td v-if="partnerState != 2">提成金额/元</td>
                    </tr>
                    <template v-for="(item , index) in diamondDataList">
                      <tr :key="index">
                          <td v-text="item.name"></td>
                          <td v-text="item.fangkaCost"></td>
                          <td v-text="item.fangkaCostNoCommission"></td>
                          <td v-text="item.fangkaCostPerformance"></td>
                          <td v-if="partnerState != 2" v-text="item.commissionAmount"></td>
                      </tr>
                    </template>
                </table>
            </div>
            <div class="part">
                <p class="title">
                    <span>场次数据</span>
                    <span class="detail-btn" @click="changciDetail">场次历史明细&gt;</span>
                </p>
                <table class="data-table">
                    <tr class="table-title">
                        <td>类别</td>
                        <td>消耗钻石总场次</td>
                        <td>无提成钻石场次</td>
                        <td>业绩钻石场次</td>
                    </tr>
                    <template v-for="(item , index) in diamondDataList">
                      <tr :key="index">
                          <td v-text="item.name"></td>
                          <td v-text="item.fangkaPlay"></td>
                          <td v-text="item.fangkaNoCommission"></td>
                          <td v-text="item.fangkaPlayPerformance"></td>
                      </tr>
                    </template>
                </table>
            </div>
      </div>
      <div class="type-con" id="type-achievement" v-show=" currentType == 3 ">
            <div class="part">
                <p class="title">
                    <span>全地区业绩考核</span>
                    <span class="detail-btn btn-show-part3">每月一号更新</span>
                </p>
                <table class="data-table">
                    <tr class="table-title">
                        <td>类别</td>
                        <td>元宝有效开房数</td>
                        <td>钻石消耗总场次</td>
                        <td>合计场次</td>
                        <td>考核场次</td>
                        <td>场次下降</td>
                        <td>提成下降</td>
                    </tr>
                    <tr v-if="assessData != null">
                        <td>上月</td>
                        <td>{{assessData.moneyCostGame}}</td>
                        <td>{{assessData.diamondCostGame}}</td>
                        <td>{{assessData.totalGame}}</td>
                        <td>{{assessData.checkGame}}</td>
                        <td>{{assessData.fallGame}}</td>
                        <td>{{assessData.fallCommission}}</td>
                    </tr>
                </table>
            </div>
            <div class="part">
                <p class="title">
                    <span>全地区业绩提成</span>
                    <span class="detail-btn btn-show-part3">每月一号更新</span>
                </p>
                <table class="data-table">
                    <tr class="table-title">
                        <td>类别</td>
                        <td>元宝提成金额</td>
                        <td>钻石提成金额</td>
                        <td>商务代理后台余额</td>
                        <td>提成下降</td>
                        <td>推荐人提成</td>
                        <td>合计提成金额</td>
                    </tr>
                    <tr v-if="commissionData != null">
                        <td>上月</td>
                        <td>{{commissionData.yuanbaoBalance}}</td>
                        <td>{{commissionData.zuanshiBalance}}</td>
                        <td>{{commissionData.moneyMemberBalance}}</td>
                        <td>{{commissionData.fallCommission}}</td>
                        <td>{{commissionData.recommendAmount}}</td>
                        <td>{{commissionData.totalAmount}}</td>
                    </tr>
                </table>
            </div>
            <div class="part">
                <p class="title">
                    <span>该地区业绩提成</span>
                    <span class="detail-btn btn-show-part3">每月一号更新</span>
                </p>
                <table class="data-table">
                    <tr class="table-title">
                        <td>类别</td>
                        <td>元宝提成金额</td>
                        <td>钻石提成金额</td>
                        <td>商务代理后台余额</td>
                        <td>提成下降</td>
                        <td>推荐人提成</td>
                        <td>合计提成金额</td>
                    </tr>
                    <tr v-if="currentCommissionData != null">
                        <td>上月</td>
                        <td>{{currentCommissionData.yuanbaoBalance}}</td>
                        <td>{{currentCommissionData.zuanshiBalance}}</td>
                        <td>{{currentCommissionData.moneyMemberBalance}}</td>
                        <td>{{currentCommissionData.fallCommission}}</td>
                        <td>{{currentCommissionData.recommendAmount}}</td>
                        <td>{{currentCommissionData.totalAmount}}</td>
                    </tr>
                </table>
            </div>
      </div>
    </div>
  </div>
</template>
<!--javascript-->
<script>
export default {
  data: function () {
    return {
      goldData: {},
      diamondData : {},
      startValue: '',
      endValue: '',
      lastClickTime: new Date().getTime() - 1300,
      currentType: '1',
      sendData: {
        type: 1//默认元宝模式
      },
      showArrowLeft: false,
      showArrowRight: true,
      partnerState : this.$store.state.userMsg.userMsg.partnerState,
      env: localStorage.getItem('env'),
      assessData : null,
      commissionData :null,
      currentCommissionData :null
    }
  },
  computed : {
      goldDataList(){
        return this.goldData;
      },
      diamondDataList(){
        return this.diamondData.list
      }
  },
  methods: {
    goldDetail(){
      this.$router.push({path : './goldDetail'})
    },  
    moneyDetail(){
      this.$router.push({path : './moneyDetail'})
    },
    changciDetail(){
      this.$router.push({path : './changciDetail'})
    },
    getData() {  
      let that = this;
      this.$http.get('/report/info', {
        params: that.sendData
      }).then((res) => { console.log(res);
        if (res.code == 0) {
            if(that.currentType == 1){
                that.goldData = {
                  moneyPayAmount : res.data.moneyPayAmount,
                  moneyDirectFanliAmount : res.data.moneyDirectFanliAmount,
                  moneyPerformanceAmount : res.data.moneyPerformanceAmount,
                  moneyTreasCnt : res.data.moneyTreasCnt,
                  moneyCommissionAmount : res.data.moneyCommissionAmount,
                  moneyMemberBalance : res.data.moneyMemberBalance,
                  list : res.data.list
                };
            } else {
                that.diamondData = res.data;
            }
        } else {
          that.$toast(res.message)
        }
      })
    },
    async getMonthData(){
      let getData = await this.$http.get('/report/performanceMonth');
      if(getData.code == 0){
        this.assessData = getData.data.assess;
        this.commissionData = getData.data.commission;
        this.currentCommissionData = getData.data.currentCommission;
      } else {
        that.$toast(res.message);
      }
    },
    changType(params) {
      let that = this;
      var clickTime = new Date().getTime()
      if (clickTime - that.lastClickTime > 1300) {
        that.lastClickTime = new Date().getTime()
      } else {
        that.$toast('操作频繁,请稍后再试')
        return
      }
      if(params != 3){
        that.sendData.type = params
        that.currentType = params
        if (this.startValue && this.endValue) {
        } else {
          that.getData((type) => {//请求成功
            that.currentType = type
          })
        }
      } else {
        that.currentType = params;
        that.getMonthData();
      }
    }
  },
  mounted: function () {
  },
  created: function () {
    this.getData();
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
.reportData {
  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.type-con{
    padding:0 0.2rem;
}
.title{
    padding:0.3rem 0;
    line-height:0.4rem;
    font-size:14px;
    color:#000;
    font-weight:600
}
.data-table{
    border-collapse: collapse;
    border-color:#fff;
    width:100%;
}
.data-table td{
    background:#F2F2F2;
    border:1px solid #fff;
    height:0.6rem;
    text-align:center;
}
.table-title td{
    background:#5357B6;
    color:#fff;
}
.detail-btn{
  float:right;
  font-weight:300;
  color:#5357B6;
}
.btn-show-part3{
  color:red;
  font-weight:600;
}
.nav {
  height: 0.7rem;
}

.focus{
  border-bottom: 1px solid #5357B6;
  color: #5357B6;
}

</style>



// WEBPACK FOOTER //
// src/components/reportData/index.vue